"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackOrderModal = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const modal_1 = require("client/components/modal");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const jwt_1 = require("server/jwt");
const po_email_template_1 = require("shared/po-email-template");
const formatUsd_1 = require("shared/util/formatUsd");
const styles = core_1.createStyles({
    btnContainer: {
        "& > *": {
            marginLeft: "1rem"
        },
        "display": "flex",
        "justifyContent": "flex-end"
    },
    header: {
        marginBottom: "1rem"
    },
    mainContent: {},
    root: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between"
    },
    row: {
        "& > *": {
            marginRight: "2rem"
        },
        "&:not(:last-child)": {
            marginBottom: "1rem"
        },
        "display": "flex"
    },
    shippingField: {
        minWidth: "0",
        width: "115px"
    },
    trackingField: {
        minWidth: "0",
        width: "150px"
    }
});
const decorate = core_1.withStyles(styles);
const Label = (props) => (React.createElement("div", null,
    React.createElement(core_1.Typography, null, props.label),
    React.createElement(core_1.Typography, null, props.value)));
let BackOrderModalUnstyled = class BackOrderModalUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.distributorIdSelected = null;
        this.distributor = null;
        this.expectedDate = null;
        this.shippingMethod = [];
        this.orderDistributorSelection = {};
        this.loadAvailableDistributors = async () => {
            const query = {
                inventoryId: this.props.poInventory.inventoryId,
                siteId: this.props.purchaseOrder.siteId
            };
            await store_1.inventoryOrderStore.loadAvailableDistributors(query);
        };
        this.handleSubmit = async () => {
            var _a, _b;
            const { poInventory } = this.props;
            const { pkgCode, inventorySiteId, inventoryId, name, inventoryOrderQuantity, totalQtyReceived, inventorySite, inventory } = poInventory;
            const pid = this.distributor.purchaseInventoryDistributor.find(pid => pid.inventoryId === inventoryId);
            if (!pid) {
                console.error("Purchase Inventory Distributor not found");
                alert("Error creatinng new PO.");
                return;
            }
            const qtyToOrder = inventoryOrderQuantity - totalQtyReceived;
            const price = pid.inventoryPrice;
            const { imbCost } = pid;
            const inventoryTotalCost = qtyToOrder * price;
            const inventoryTotalImbCost = qtyToOrder * imbCost;
            const purchaseOrderInventories = [];
            const orderInventory = {
                description: "",
                distributor: this.distributor.distributor,
                inventoryId,
                inventoryOrderQuantity: qtyToOrder,
                inventorySiteId,
                inventoryTotalCost,
                inventoryTotalImbCost,
                max: inventorySite ? inventorySite.max : 0,
                min: inventorySite ? inventorySite.min : 0,
                name,
                note: "",
                pkgCode,
                price,
                quantityOnHand: inventorySite ? inventorySite.quantity : 0
            };
            purchaseOrderInventories.push(orderInventory);
            const site = (_b = (_a = store_2.sitesListStore === null || store_2.sitesListStore === void 0 ? void 0 : store_2.sitesListStore.sites) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find((site) => site.id === inventorySite.siteId);
            const shippingMethod = [
                {
                    id: this.distributor.id,
                    method: this.shippingMethod,
                    distributor: this.distributor.distributor
                }
            ];
            const purchaseOrder = {
                note: "",
                orderDescription: `Inventory Backorder: ndc package ${pkgCode} ${inventory.strengthDescription ||
                    inventory.name}`,
                orderInventories: purchaseOrderInventories,
                orderName: ``,
                orderTotalCost: inventoryTotalCost,
                pharmacyName: site ? site.displayName : "No pharmacy display name",
                shippingMethods: shippingMethod,
                siteId: inventorySite.siteId,
                transactionPONumber: ""
            };
            const siteApprovalEmailAdd = site.settings.orderApprovalEmailAddress.value; // D-023.2
            // D-023.2
            const comapnyDetailsBySite = await store_1.inventoryOrderStore.loadSiteComapnyDetailsInfo(inventorySite.siteId); // D-023.2
            let comapnyEmailAdd;
            if (comapnyDetailsBySite) {
                await comapnyDetailsBySite.map((approvalEmail) => {
                    comapnyEmailAdd = approvalEmail.CompanyApprovalOrderEmail;
                });
            } // D-023.2
            const isPOEmailAssociated = !comapnyEmailAdd && !siteApprovalEmailAdd
                ? "(ASSOCIATED EMAIL WAS NOT FOUND)"
                : ""; // D-023
            const savedOrder = await store_1.inventoryOrderStore.createPurchaseOrder(purchaseOrder);
            const byDefaultEmail = "support@integrativeaconsult.com"; // D-023.2
            const associatesEmails = (comapnyEmailAdd && siteApprovalEmailAdd) ? `${comapnyEmailAdd}; ${siteApprovalEmailAdd}` : comapnyEmailAdd ? comapnyEmailAdd : siteApprovalEmailAdd; // E-053.11
            if (savedOrder) {
                // Save backorder metadata
                try {
                    await store_1.inventoryOrderStore.createBackorder(poInventory, savedOrder);
                }
                catch (err) {
                    console.error("Error creating backorder", err);
                }
                // @tk use inventoryOrderStore to send an alert notifying order pending approval.
                try {
                    await store_1.inventoryOrderStore.sendPurchaseOrderSubmissionAlert(savedOrder);
                }
                catch (err) {
                    console.error("Error sending PO submission alert", err);
                }
                // const mailToEmail = "info@billogix.com";
                const mailToEmail = associatesEmails || byDefaultEmail; // D-023 E-053 E-053.11
                const emailToken = jwt_1.sign(mailToEmail);
                const purchaseOrderTable = po_email_template_1.buildPOTable(savedOrder, emailToken);
                const emailTemplate = po_email_template_1.getPOEmailTemplate("New PO Pending", "Purchase Order Pending Approval", purchaseOrderTable);
                let result;
                try {
                    result = await store_1.inventoryOrderStore.sendEmailAlert(emailTemplate, savedOrder, mailToEmail, isPOEmailAssociated); // D-023
                }
                catch (err) {
                    console.error("Error sending email alert for new PO from backorder", err);
                }
                if (!result || !result.success) {
                    alert("Error in sending email alert");
                    console.log("result ---", result === null || result === void 0 ? void 0 : result.success);
                }
                // Update Ui
                await this.props.updateUi();
                // Cancel POI
                await this.props.onCancelInventory(poInventory);
            }
            else {
                alert("Error: purchase order was not saved to the database. \n Redirecting to the dashboard.");
            }
        };
        this.handleExpectedDateChange = (value) => {
            this.expectedDate = value;
        };
        this.renderNewPo = () => {
            const { classes, poInventory } = this.props;
            const { inventory: { id: inventoryId }, inventoryOrderQuantity, totalQtyReceived } = poInventory;
            let distributorCost = "";
            if (this.distributor) {
                const { purchaseInventoryDistributor } = this.distributor;
                const pid = purchaseInventoryDistributor.find(pid => String(pid.inventoryId) === String(inventoryId));
                if (pid) {
                    distributorCost = pid.inventoryPrice;
                }
            }
            const qtyToOrder = inventoryOrderQuantity - totalQtyReceived;
            return (React.createElement("div", null,
                React.createElement(core_1.Typography, null, "Please select a distributor to proceed with a new purchase order."),
                React.createElement("div", { className: classes.row },
                    React.createElement(select_1.MaterialSelect, { className: "edit-order-header__select-site", options: this.availableOptions, required: true, searchable: true, label: "Distributor", onSelect: value => {
                            this.distributorIdSelected = value;
                            this.distributor = store_1.inventoryOrderStore.availableBackorderDistributors.find(distributor => String(distributor.id) === String(value));
                            console.info("this.distributor", this.distributor);
                        }, value: this.distributorIdSelected }),
                    React.createElement(Label, { label: "Distributor Cost", value: distributorCost ? formatUsd_1.formatUsd(Number(distributorCost)) : "" }),
                    React.createElement(Label, { label: "Quantity", value: qtyToOrder }),
                    React.createElement(Label, { label: "Total Cost", value: this.totalCost })),
                React.createElement(select_1.MaterialSelect, { className: "edit-order-header__select-site", options: this.shippingOptions, required: true, label: "Shipping", onSelect: v => {
                        this.shippingMethod = v;
                    }, value: this.shippingMethod || "" })));
        };
        this.renderExpectedDelivery = () => (React.createElement("div", null,
            React.createElement(core_1.Typography, { gutterBottom: true }, "There are no available distributor to proceed with a new purchase order. Please indicate an expected availability date."),
            React.createElement(date_picker_1.MaterialDatePicker, { className: "lot-add-form__item lot-add-form__expire-date", label: "Expected Availability", onChange: this.handleExpectedDateChange, value: this.expectedDate })));
        this.handleCreateBackorderPo = () => {
            try {
                this.handleSubmit();
            }
            catch (err) {
                console.error("Error on submit create new PO for backorder", err);
            }
            finally {
                this.props.onCancel();
            }
        };
        this.handleUpdateExpectedBackorderDate = async () => {
            console.info("inside handleupdateExpectedBackorderDate");
            const { poInventory, purchaseOrder } = this.props;
            try {
                await store_1.inventoryOrderStore.updateExpectedBackorderDate(poInventory, purchaseOrder, this.expectedDate);
                await this.props.updateUi();
            }
            catch (err) {
                console.error("Error updating expected backorder date", err);
            }
            finally {
                this.props.onCancel();
            }
        };
    }
    get availableOptions() {
        return store_1.inventoryOrderStore.availableBackorderDistributors
            .filter(distributor => distributor.distributor !== this.props.poInventory.distributor)
            .map(distributor => ({
            id: distributor.id,
            label: distributor.distributor,
            value: distributor.id
        }));
    }
    get isAvailableDistributors() {
        return Boolean(this.availableOptions.length);
    }
    get totalCost() {
        const { poInventory } = this.props;
        const { inventory: { id: inventoryId }, inventoryOrderQuantity, totalQtyReceived } = poInventory;
        let totalCost = "";
        if (this.distributor) {
            const { purchaseInventoryDistributor } = this.distributor;
            const pid = purchaseInventoryDistributor.find(pid => String(pid.inventoryId) === String(inventoryId));
            if (pid) {
                const distributorCost = pid.inventoryPrice;
                const qtyToOrder = inventoryOrderQuantity - totalQtyReceived;
                totalCost = formatUsd_1.formatUsd(distributorCost * qtyToOrder);
            }
        }
        return totalCost;
    }
    async componentDidMount() {
        await this.loadAvailableDistributors();
    }
    get shippingOptions() {
        return this.distributor
            ? this.distributor.shippingOptions.map((option, i) => ({
                id: i,
                label: option.method,
                value: option.method.toString()
            }))
            : [];
    }
    render() {
        const { classes, poInventory } = this.props;
        console.info("poInventory in backorder modal component", poInventory);
        const { inventory: { strengthDescription, package: ndcPackage } } = poInventory;
        return (React.createElement(modal_1.Modal, { width: "600px", height: "400px", onCancel: this.props.onCancel },
            React.createElement("div", { className: classes.root },
                React.createElement("div", { className: classes.mainContent },
                    React.createElement("div", { className: classes.header },
                        React.createElement(core_1.Typography, { gutterBottom: true, variant: "headline" }, "Inventory Backorder"),
                        React.createElement(core_1.Typography, { gutterBottom: true, variant: "subheading" }, strengthDescription),
                        React.createElement(core_1.Typography, { gutterBottom: true, variant: "caption" }, ndcPackage)),
                    this.isAvailableDistributors
                        ? this.renderNewPo()
                        : this.renderExpectedDelivery()),
                React.createElement("div", { className: classes.btnContainer },
                    React.createElement(button_1.MaterialButton, { onClick: this.props.onCancel }, "Cancel"),
                    React.createElement(button_1.MaterialButton, { primary: true, disabled: this.isAvailableDistributors
                            ? !this.distributorIdSelected
                            : !this.expectedDate, onClick: this.isAvailableDistributors
                            ? this.handleCreateBackorderPo
                            : this.handleUpdateExpectedBackorderDate }, this.isAvailableDistributors
                        ? "Submit PO"
                        : "Update Expected Date")))));
    }
};
__decorate([
    mobx_1.observable
], BackOrderModalUnstyled.prototype, "distributorIdSelected", void 0);
__decorate([
    mobx_1.observable
], BackOrderModalUnstyled.prototype, "distributor", void 0);
__decorate([
    mobx_1.observable
], BackOrderModalUnstyled.prototype, "expectedDate", void 0);
__decorate([
    mobx_1.observable
], BackOrderModalUnstyled.prototype, "shippingMethod", void 0);
__decorate([
    mobx_1.observable
], BackOrderModalUnstyled.prototype, "orderDistributorSelection", void 0);
__decorate([
    mobx_1.computed
], BackOrderModalUnstyled.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], BackOrderModalUnstyled.prototype, "isAvailableDistributors", null);
__decorate([
    mobx_1.computed
], BackOrderModalUnstyled.prototype, "totalCost", null);
__decorate([
    mobx_1.computed
], BackOrderModalUnstyled.prototype, "shippingOptions", null);
BackOrderModalUnstyled = __decorate([
    mobx_react_1.observer
], BackOrderModalUnstyled);
exports.BackOrderModal = decorate(BackOrderModalUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/back-order-modal/back-order-modal.tsx
// module id = 3572
// module chunks = 0